<!--<div class="pagination">
  <div>
    <div *ngIf="currentPage > 1" (click)="previousPage()">
      <svg width="30" height="30" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg" style="transform: rotateY(180deg);">
        <rect x="0.75" y="0.25" width="24.5" height="24.5" stroke="#5F6366" stroke-width="0.5" style="transform: rotateY(180deg);"/>
        <rect x="0.75" y="0.25" width="24.5" height="24.5" stroke="black" stroke-opacity="0.2" stroke-width="0.5" />
        <rect x="0.75" y="0.25" width="24.5" height="24.5" stroke="black" stroke-opacity="0.2" stroke-width="0.5" />
        <rect x="0.75" y="0.25" width="24.5" height="24.5" stroke="black" stroke-opacity="0.2" stroke-width="0.5" />
        <path d="M10 6.5L16 12.5L10 18.5" stroke="#5F6366" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M10 6.5L16 12.5L10 18.5" stroke="black" stroke-opacity="0.2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M10 6.5L16 12.5L10 18.5" stroke="black" stroke-opacity="0.2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M10 6.5L16 12.5L10 18.5" stroke="black" stroke-opacity="0.2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>
  </div>
  <div>
    <div *ngIf="currentPage < totalPages" (click)="nextPage()">
      <svg width="30" height="30" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.75" y="0.25" width="24.5" height="24.5" stroke="#5F6366" stroke-width="0.5" style="transform: rotateY(180deg);"/>
        <rect x="0.75" y="0.25" width="24.5" height="24.5" stroke="black" stroke-opacity="0.2" stroke-width="0.5" />
        <rect x="0.75" y="0.25" width="24.5" height="24.5" stroke="black" stroke-opacity="0.2" stroke-width="0.5" />
        <rect x="0.75" y="0.25" width="24.5" height="24.5" stroke="black" stroke-opacity="0.2" stroke-width="0.5" />
        <path d="M10 6.5L16 12.5L10 18.5" stroke="#5F6366" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M10 6.5L16 12.5L10 18.5" stroke="black" stroke-opacity="0.2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M10 6.5L16 12.5L10 18.5" stroke="black" stroke-opacity="0.2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M10 6.5L16 12.5L10 18.5" stroke="black" stroke-opacity="0.2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>
  </div>
</div>-->

<div class="pagination">
  <div>
    <div *ngIf="currentPage > 1" (click)="previousPage()">
      <svg width="30" height="30" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg" style="transform: rotateY(180deg);">
        <path d="M10 6.5L16 12.5L10 18.5" stroke="#5F6366" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>
  </div>
  <div>
    <div *ngIf="currentPage < totalPages" (click)="nextPage()">
      <svg width="30" height="30" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 6.5L16 12.5L10 18.5" stroke="#5F6366" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>
  </div>
</div>
